import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pagination-nav',
  templateUrl: './pagination-nav.component.html',
  styleUrls: ['./pagination-nav.component.css']
})
export class PaginationNavComponent {
  @Input() totalPages: number = 0;
  @Input() currentPage: number = 1;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  get canGoPrevious() {
    return this.currentPage > 1;
  }

  get canGoNext() {
    return this.currentPage < this.totalPages;
  }

  get visiblePages(): Array<number> {
    if (this.totalPages <= 0) {
      return [];
    }

    if (this.totalPages <= 7) {
      const allPages: Array<number> = [];
      for (let i = 1; i <= this.totalPages; i++) {
        allPages.push(i);
      }
      return allPages;
    }

    const pages: Array<number> = [1, 2, 3, this.currentPage, this.totalPages - 2, this.totalPages - 1, this.totalPages];
    const uniquePages: Array<number> = [];

    pages
      .filter((page) => page >= 1 && page <= this.totalPages)
      .sort((a, b) => a - b)
      .forEach((page) => {
        if (uniquePages.indexOf(page) === -1) {
          uniquePages.push(page);
        }
      });

    return uniquePages;
  }

  showEllipsisAfter(index: number): boolean {
    if (index >= this.visiblePages.length - 1) {
      return false;
    }

    return this.visiblePages[index + 1] - this.visiblePages[index] > 1;
  }

  navigatePage(page: number) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) {
      return;
    }

    this.pageChange.emit(page);
  }

  goToPreviousPage() {
    this.navigatePage(this.currentPage - 1);
  }

  goToNextPage() {
    this.navigatePage(this.currentPage + 1);
  }
}